import { useEffect, useState } from 'react'
import { GetCardTransactionsParams } from '@web/walter-lib/api'
import { useCardTransactionsList } from '~api'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

const getRequestParams = (cardId?: string, cursor?: string) => {
    if (!cardId) {
        return { id: '' }
    }

    const requestParams: GetCardTransactionsParams = {
        id: cardId,
        cursor,
        limit: 30,
    }

    return requestParams
}

//eslint-disable-next-line complexity, max-lines-per-function
export const useTransactionsList = (cardId?: string) => {
    const [hasMore, setHasMore] = useState(true)
    const [cursor, setCursor] = useState<string | undefined>()
    const [isInitialLoad, setIsInitialLoad] = useState(true)
    const [data, setData] = useState<Transaction[] | null>(null)
    const [isError, setIsError] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const requestParams = getRequestParams(cardId, cursor)

    const {
        data: nextPortion,
        error,
        mutate,
    } = useCardTransactionsList({
        shouldRequest: isLoading && !isError,
        params: requestParams,
        revalidateOnMount: true,
    })

    const fetchNext = () => {
        if (isError) {
            mutate(undefined, { revalidate: false })
        }

        setIsLoading(true)
        setIsError(false)
    }

    useEffect(() => {
        if (nextPortion !== undefined) {
            try {
                const transactions = nextPortion?.transactions || []
                const isMoreDataAvailable = nextPortion?.next_cursor

                setData(prevData => {
                    return [...(prevData ?? []), ...transactions]
                })

                if (!isMoreDataAvailable) {
                    setHasMore(false)
                } else {
                    setCursor(nextPortion?.next_cursor)
                }
            } catch (error) {
                setIsError(true)
            }

            setIsInitialLoad(false)
            setIsLoading(false)
        }
    }, [nextPortion])

    useEffect(() => {
        if (error) {
            setIsLoading(false)
            setIsError(true)
        }
    }, [error])

    return {
        data,
        isError,
        fetchNext,
        hasMore,
        isLoading,
        isInitialLoad,
    }
}
